import { loadIntersectionObserver } from '../util/load-dependencies';
import { createSingleUseObserver } from '../util/intersection-observer';

class BlockContentMedia {
	constructor(blockEl) {
		this.blockEl = blockEl;
		this.mediaType = this.blockEl.getAttribute('data-media-type') ?? 'image';
		this.videoEl = null;
		this.videoCanPlayThrough = false;
		this.videoPlayRequested = false;

		if (this.mediaType === 'video') {
			this.createVideoPlaybackObserver();
		}
	}

	async createVideoPlaybackObserver() {
		try {
			const ioAvailable = await loadIntersectionObserver();

			this.videoEl = this.blockEl.querySelector('video');

			if (this.videoEl instanceof HTMLMediaElement) {
				if (this.videoEl.readyState >= 4) {
					this.videoCanPlayThrough = true;
				} else {
					this.videoEl.addEventListener('canplaythrough', () => {
						this.videoCanPlayThrough = true;

						if (this.videoPlayRequested) {
							this.videoEl.play();
						}
					});
				}

				createSingleUseObserver(
					this.videoEl,
					() => {
						if (this.videoCanPlayThrough) {
							this.videoEl.play();
						} else {
							this.videoPlayRequested = true;
						}
					},
					{
						vpThresholds: { 0: 1 }
					}
				);
			}
		} catch (err) {
			console.error(err);
		}
	}
}

export default BlockContentMedia;
